<template>
  <div
    class="size-full sm:bg-[url('@/assets/backgrounds/moneycombe_bg_texture.svg')]"
  >
    <BaseInnerLoading
      v-if="isFetchingAuthStatus || isFetchingCurrentTenant"
    />

    <RouterView
      v-else-if="currentTenant?.hasBeepaidGoModule"
    />

    <MerchantNotFound v-else />
  </div>
</template>

<script setup lang="ts">
import { useHead } from "@unhead/vue"
import { api } from "@/services/api"
const { isLoggedIn, isFetchingAuthStatus } = useAuth()

const {
  currentTenant,
  isFetching: isFetchingCurrentTenant,
} = useCurrentTenant()

const { pageTitle } = usePageTitle()
const router = useRouter()
const route = useRoute()

useHead({
  title: pageTitle,
  titleTemplate: (title: string | undefined) =>
    title ? `beepaidGo | ${title}` : `beepaidGo`,
})

onMounted(() => {
  api.get("/beepaidgo/get-csrf-token/")
})

whenever(
  () =>
    !isFetchingAuthStatus.value &&
    !isLoggedIn.value &&
    currentTenant.value?.hasBeepaidGoModule &&
    route.meta.auth === true,
  () => {
    router.push({ name: "login" })
  },
  { immediate: true }
)
</script>

<style lang="scss">
html {
  --color-secondary: 238 124 10;
  --color-accent: 232 81 36;
}

input[type="number"] {
  appearance: textfield;
  margin: 0;
}

input[type="number"]::-webkit-inner-spin-button {
  appearance: none;
}
</style>
